<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] flex flex-col">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Produto</h3>
            <AppButton style="color: var(--icon);" class=" self-end text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="close" :width=23 :height=23 /> 
        </div>

        <div class="flex gap-2 w-full">
            <div class=" left-input-field flex flex-col gap-4">
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">Produto:</label>
                    <input  style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="produto" v-model="model.nome" placeholder="Produto">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="numero">Descrição:</label>
                    <textarea  style="background-color: var(--label);" v-model="model.descricao" placeholder="Descrição" class="rounded-[5px] p-1 resize-none w-[100%] h-[100%] placeholder:text-[12px] text-black"></textarea>                
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Tipo:</label>
                    <select v-model="model.tpProduto_id" class="max-w-[6rem] text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] " placeholder="Tipo de Produto">
                        <option  style="background-color: var(--label);" v-for="option in tipos" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input  style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.status" placeholder="Status">
                </div>
                
            </div>

            
                
                <AppTable :visibility="true" :show="true" :table_data="produtos" table_title="Produtos"
                  @row-clicked="select_produto" @close="close_table" :show_multiSelect="false" />
                
          

        </div>
        
    </div>
</template>



<script>
    import AppButton from '@/components/updated/button.vue'
    import AppTable from '@/components/tables/table.vue'
    import axios from 'axios'
    export default{
        name: 'AppProduto',
        components: {
            AppButton,
            AppTable
            
        },

        props: {
            
        },

        data(){
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                model:{
                    produto:'',
                    descricao:'',
                    status:'',
                    tpProduto_id:0,
                },
                tipos:[],
                produtos:[],
                
            }
        },

        async created(){
            this.tipos= await this.select_all(`${this.baseURl}/api/v1/tpproduto/`);
            this.produtos= await this.select_all(`${this.baseURl}/api/v1/produto/`);
            
        },

        methods: {
            close() {
                this.$emit('close');
            },
            async create(data, url) {
              try {
                  const res = await axios.post(url, data);
                  return res.data.data;
              } catch (error) {
                  console.error('Error getting data:', error);
              }
            },
  
            async select(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;
                } catch (error) {
                    console.error('Error getting data:', error);
                }
            },
        
            async select_all(url) {
                try {
                    const res = await axios.get(url);
                    return res.data.data;
        
                } catch (error) {
                    console.error('Error getting data:', error);
                }
        
            },
        
            async update(url, data) {
        
                try {
                    const res = await axios.put(url, data);
                    console.log('Data successfully updated:', res.data);
                    return res.data.data;
        
                } catch (error) {
                    console.error('Error posting data:', error);
                }
            },
        
            async remove(url) {
                // console.log("Data:", data.id)
                try {
                    await axios.delete(url);
                    return true;
                } catch (error) {
                    console.error('Error deleting data:', error);
                }
            },
            
        }
    }
    

</script>




<style>
.text-black {
    color: var(--text);
}


</style>